/* AUTO-GENERATED by .context/gen-skilldrills.js — do not edit by hand.
 * Hardcoded recruit skill-drill catalogue (BC Structure FF / Viera standard).
 * Maps the 231 NFPA/IFSTA skill drills to their Viera qualification cell
 * ({group, skillKey}.practical) and exam (theory). Not tenant-editable. See #1004. */
const SkillDrills = {
    'exterior': {
        'key': 'exterior',
        'label': 'Exterior Operations',
        'order': 1,
        'chapters': [
            {
                'chapter': 1,
                'label': 'The Fire Service',
                'group': 'truckReady',
                'skillKey': 'ch1FireService',
                'exam': 1,
                'drills': [],
                'theoryOnly': true
            },
            {
                'chapter': 4,
                'label': 'Fire Service Comms',
                'group': 'truckReady',
                'skillKey': 'ch4Comms',
                'exam': 1,
                'drills': [
                    {
                        'code': '4-1',
                        'name': 'Receiving a Call and Initiating a Response to an Emergency',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '4-3',
                        'name': 'Using a Radio',
                        'level': 'Fire Fighter I'
                    }
                ]
            },
            {
                'chapter': 2,
                'label': 'FF Health & Safety',
                'group': 'truckReady',
                'skillKey': 'ch2Safety',
                'exam': 2,
                'drills': [
                    {
                        'code': '2-1',
                        'name': 'Mounting Apparatus',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '2-2',
                        'name': 'Dismounting a Stopped Apparatus',
                        'level': 'Fire Fighter I'
                    }
                ]
            },
            {
                'chapter': 3,
                'label': 'PPE & SCBA',
                'group': 'truckReady',
                'skillKey': 'ch3Ppe',
                'exam': 2,
                'drills': [
                    {
                        'code': '3-1',
                        'name': 'Donning Personal Protective Clothing',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '3-2',
                        'name': 'Doffing Personal Protective Clothing',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '3-3',
                        'name': 'Donning an SCBA from an Apparatus Seat Mount',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '3-4',
                        'name': 'Donning an SCBA from an Apparatus Compartment Mount',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '3-5',
                        'name': 'Donning an SCBA Using the Over-the-Head Method',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '3-6',
                        'name': 'Donning an SCBA Using the Coat Method',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '3-7',
                        'name': 'Donning a Face Piece',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '3-8',
                        'name': 'Doffing an SCBA',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '3-9',
                        'name': 'Visible SCBA Inspection',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '3-10',
                        'name': 'SCBA Operational Inspection',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '3-11',
                        'name': 'Replacing an SCBA Cylinder',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '3-12',
                        'name': 'Replacing an SCBA Cylinder on Another Fire Fighter',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '3-13',
                        'name': 'Refilling SCBA Cylinders',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '3-14',
                        'name': 'Cleaning an SCBA',
                        'level': 'Fire Fighter I'
                    }
                ]
            },
            {
                'chapter': 14,
                'label': 'Water Supply',
                'group': 'exterior',
                'skillKey': 'ch14Water',
                'exam': 3,
                'drills': [
                    {
                        'code': '14-1',
                        'name': 'Operating a Dry-Barrel Fire Hydrant',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '14-2',
                        'name': 'Shutting Down a Dry-Barrel Fire Hydrant',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '14-6',
                        'name': 'Assisting the Pump Driver/Operator with Drafting',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '14-7',
                        'name': 'Setting Up a Portable Tank',
                        'level': 'Fire Fighter I'
                    }
                ]
            },
            {
                'chapter': 15,
                'label': 'Hose & Nozzles',
                'group': 'exterior',
                'skillKey': 'ch15Hose',
                'exam': 3,
                'drills': [
                    {
                        'code': '15-1',
                        'name': 'Replacing the Swivel Gasket',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '15-2',
                        'name': 'One-Fire Fighter Foot-Tilt Method of Coupling a Fire Hose',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '15-3',
                        'name': 'Two-Fire Fighter Method of Coupling a Fire Hose',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '15-4',
                        'name': 'One-Fire Fighter Knee-Press Method of Uncoupling a Fire Hose',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '15-5',
                        'name': 'Two-Fire Fighter Stiff-Arm Method of Uncoupling a Fire Hose',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '15-6',
                        'name': 'Uncoupling a Hose with Spanner Wrenches (Hose Keys)',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '15-7',
                        'name': 'Cleaning and Maintaining Hose',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '15-8',
                        'name': 'Marking a Defective Hose',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '15-9',
                        'name': 'Performing a Straight or Storage Hose Roll',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '15-10',
                        'name': 'Performing a Single-Doughnut Hose Roll',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '15-11',
                        'name': 'Performing a Twin-Doughnut Hose Roll',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '15-12',
                        'name': 'Performing a Self-Locking Twin-Doughnut Hose Roll',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '15-13',
                        'name': 'Using a Hose Jacket',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '15-14',
                        'name': 'Operating a Smooth-Bore Nozzle',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '15-15',
                        'name': 'Operating a Fog-Stream Nozzle',
                        'level': 'Fire Fighter I'
                    }
                ]
            },
            {
                'chapter': 16,
                'label': 'Supply Line & Attack',
                'group': 'exterior',
                'skillKey': 'ch16Supply',
                'exam': 4,
                'drills': [
                    {
                        'code': '16-1',
                        'name': 'Performing a Forward Hose Lay',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-2',
                        'name': 'Attaching a Fire Hose to a Four-Way Hydrant Valve',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-3',
                        'name': 'Performing a Reverse Hose Lay',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-4',
                        'name': 'Performing a Split Hose Lay',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-5',
                        'name': 'Performing a Flat Hose Load',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-6',
                        'name': 'Performing a Horseshoe Hose Load',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-7',
                        'name': 'Performing an Accordion Hose Load',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-8',
                        'name': 'Attaching a Soft Sleeve Hose to a Fire Hydrant',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-9',
                        'name': 'Performing a Working Hose Drag',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-10',
                        'name': 'Performing a Shoulder Carry',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-11',
                        'name': 'Advancing an Accordion Load',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-12',
                        'name': 'Connecting a Hose Line to Supply a Fire Department Connection',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-13',
                        'name': 'Performing a Minuteman Hose Load',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-14',
                        'name': 'Advancing a Minuteman Hose Load',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-15',
                        'name': 'Performing a Pre-connected Flat Hose Load',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-16',
                        'name': 'Advancing a Pre-connected Flat Hose Load',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-17',
                        'name': 'Performing a Triple-Layer Hose Load',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-18',
                        'name': 'Advancing a Triple-Layer Hose Load',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-19',
                        'name': 'Unloading and Advancing Wyed Lines',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-20',
                        'name': 'Advancing an Attack Line up a Stairway',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-21',
                        'name': 'Advancing an Attack Line down a Stairway',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-22',
                        'name': 'Advancing an Uncharged Attack Line up a Ladder',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-23',
                        'name': 'Operating an Attack Line from a Ladder',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-24',
                        'name': 'Connecting and Advancing an Attack Line from a Standpipe Outlet',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-25',
                        'name': 'Replacing a Damaged Section of Hose',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '16-26',
                        'name': 'Draining a Hose',
                        'level': 'Fire Fighter I'
                    }
                ]
            },
            {
                'chapter': 9,
                'label': 'Ropes & Knots',
                'group': 'exterior',
                'skillKey': 'ch9Ropes',
                'exam': 5,
                'drills': [
                    {
                        'code': '9-1',
                        'name': 'Caring for Life Safety Ropes',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-2',
                        'name': 'Cleaning Fire Department Ropes',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-3',
                        'name': 'Inspecting Fire Department Ropes',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-4',
                        'name': 'Placing a Life Safety Rope in a Rope Bag',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-5',
                        'name': 'Tying a Safety Knot',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-6',
                        'name': 'Tying a Half Hitch',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-7',
                        'name': 'Tying a Clove Hitch in the Open',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-8',
                        'name': 'Tying a Clove Hitch Around an Object',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-9',
                        'name': 'Tying a Figure Eight Knot',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-10',
                        'name': 'Tying a Figure Eight on a Bight',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-11',
                        'name': 'Tying a Figure Eight Follow-Through',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-12',
                        'name': 'Tying a Figure Eight Bend',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-13',
                        'name': 'Tying a Bowline',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-14',
                        'name': 'Tying a Sheet or Becket Bend',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-15',
                        'name': 'Tying a Water Knot',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-16',
                        'name': 'Hoisting an Axe',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-17',
                        'name': 'Hoisting a Pike Pole',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-18',
                        'name': 'Hoisting a Ladder',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-19',
                        'name': 'Hoisting a Charged Hose Line',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-20',
                        'name': 'Hoisting an Uncharged Hose Line',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '9-21',
                        'name': 'Hoisting an Exhaust Fan or Power Tool',
                        'level': 'Fire Fighter I'
                    }
                ]
            },
            {
                'chapter': 11,
                'label': 'Ladders',
                'group': 'exterior',
                'skillKey': 'ch11Ladders',
                'exam': 5,
                'drills': [
                    {
                        'code': '11-1',
                        'name': 'Inspect, Clean, and Maintain a Ladder',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-2',
                        'name': 'One-Fire Fighter Shoulder Carry',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-3',
                        'name': 'Two-Fire Fighter Shoulder Carry',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-4',
                        'name': 'Three-Fire Fighter Shoulder Carry',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-5',
                        'name': 'Two-Fire Fighter Suitcase Carry',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-6',
                        'name': 'Three-Fire Fighter Suitcase Carry',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-7',
                        'name': 'Three-Fire Fighter Flat Carry',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-8',
                        'name': 'Four-Fire Fighter Flat Carry',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-9',
                        'name': 'Three-Fire Fighter Flat Shoulder Carry',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-10',
                        'name': 'Four-Fire Fighter Flat Shoulder Carry',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-11',
                        'name': 'One-Fire Fighter Flat Raise — Ladders Less Than 4 m (14 ft)',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-12',
                        'name': 'One-Fire Fighter Flat Raise — Ladders More Than 4 m (14 ft)',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-13',
                        'name': 'Tying the Halyard',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-14',
                        'name': 'Two-Fire Fighter Beam Raise',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-15',
                        'name': 'Two-Fire Fighter Flat Raise',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-16',
                        'name': 'Three-Fire Fighter Flat Raise',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-17',
                        'name': 'Four-Fire Fighter Flat Raise',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-18',
                        'name': 'Climbing a Ladder While Carrying a Tool',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-19',
                        'name': 'Using a Leg Lock to Work from a Ladder',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-20',
                        'name': 'Deploying a Roof Ladder',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '11-21',
                        'name': 'Inspecting a Chimney',
                        'level': 'Fire Fighter I'
                    }
                ]
            },
            {
                'chapter': 5,
                'label': 'Fire Behaviour',
                'group': 'exterior',
                'skillKey': 'ch5FireBehaviour',
                'exam': 6,
                'drills': [],
                'theoryOnly': true
            },
            {
                'chapter': 6,
                'label': 'Building Construction',
                'group': 'exterior',
                'skillKey': 'ch6Building',
                'exam': 6,
                'drills': [],
                'theoryOnly': true
            },
            {
                'chapter': 13,
                'label': 'Ventilation',
                'group': 'exterior',
                'skillKey': 'ch13Ventilation',
                'exam': 7,
                'drills': [
                    {
                        'code': '13-1',
                        'name': 'Breaking Glass with a Hand Tool',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '13-2',
                        'name': 'Breaking Windows with a Ladder',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '13-3',
                        'name': 'Delivering Negative-Pressure Ventilation',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '13-4',
                        'name': 'Delivering Positive-Pressure Ventilation',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '13-5',
                        'name': 'Delivering Hydraulic Ventilation',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '13-6',
                        'name': 'Operating a Power Saw',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '13-7',
                        'name': 'Making a Rectangular or Square Cut',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '13-8',
                        'name': 'Making a Seven, Nine, Eight (7, 9, 8) Rectangular Cut',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '13-9',
                        'name': 'Making a Louver Cut',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '13-10',
                        'name': 'Making a Triangular Cut',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '13-11',
                        'name': 'Making a Peak Cut',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '13-12',
                        'name': 'Making a Trench Cut',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '13-13',
                        'name': 'Performing a Readiness Check on a Power Saw',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '13-14',
                        'name': 'Maintaining a Power Saw',
                        'level': 'Fire Fighter I'
                    }
                ]
            },
            {
                'chapter': 22,
                'label': 'Establish & Transfer Command',
                'group': 'exterior',
                'skillKey': 'ch22Command',
                'exam': 7,
                'drills': [
                    {
                        'code': '22-1',
                        'name': 'Operating Within the ICS',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '22-2',
                        'name': 'Establishing Command',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '22-3',
                        'name': 'Transferring Command',
                        'level': 'Fire Fighter II'
                    }
                ]
            },
            {
                'chapter': 17,
                'label': 'Fire Suppression (Live Fire)',
                'group': 'exterior',
                'skillKey': 'ch17LiveFire',
                'exam': 8,
                'drills': [
                    {
                        'code': '17-1',
                        'name': 'Performing the Transitional Attack',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '17-2',
                        'name': 'Performing a Direct Attack',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '17-3',
                        'name': 'Performing an Indirect Attack',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '17-4',
                        'name': 'Performing a Combination Attack',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '17-5',
                        'name': 'One-Fire Fighter Method for Operating a Large Handline',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '17-6',
                        'name': 'Two-Fire Fighter Method for Operating a Large Handline',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '17-7',
                        'name': 'Operating a Deck Gun',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '17-8',
                        'name': 'Operating a Portable Monitor',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '17-9',
                        'name': 'Locating and Suppressing Concealed-Space Fires',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '17-10',
                        'name': 'Extinguishing an Outside Class A Fire',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '17-11',
                        'name': 'Extinguishing a Vehicle Fire',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '17-12',
                        'name': 'Shutting Off Gas Utilities',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '17-13',
                        'name': 'Shutting Off Electrical Utilities',
                        'level': 'Fire Fighter I'
                    }
                ]
            },
            {
                'chapter': 21,
                'label': 'Wildland & Ground Fires',
                'group': 'exterior',
                'skillKey': 'ch21Wildland',
                'exam': 8,
                'drills': [
                    {
                        'code': '21-1',
                        'name': 'Suppressing a Ground Cover Fire',
                        'level': 'Fire Fighter I'
                    }
                ]
            }
        ],
        'exams': [
            {
                'exam': 1,
                'label': 'Written Exam 1',
                'chapters': [
                    1,
                    4
                ]
            },
            {
                'exam': 2,
                'label': 'Written Exam 2',
                'chapters': [
                    2,
                    3
                ]
            },
            {
                'exam': 3,
                'label': 'Written Exam 3',
                'chapters': [
                    14,
                    15
                ]
            },
            {
                'exam': 4,
                'label': 'Written Exam 4',
                'chapters': [
                    16
                ]
            },
            {
                'exam': 5,
                'label': 'Written Exam 5',
                'chapters': [
                    9,
                    11
                ]
            },
            {
                'exam': 6,
                'label': 'Written Exam 6',
                'chapters': [
                    5,
                    6
                ]
            },
            {
                'exam': 7,
                'label': 'Written Exam 7',
                'chapters': [
                    13,
                    22
                ]
            },
            {
                'exam': 8,
                'label': 'Written Exam 8',
                'chapters': [
                    17,
                    21
                ]
            }
        ]
    },
    'interior': {
        'key': 'interior',
        'label': 'Interior Operations',
        'order': 2,
        'chapters': [
            {
                'chapter': 12,
                'label': 'Search & Rescue',
                'group': 'interior',
                'skillKey': 'ch12SearchRescue',
                'exam': 9,
                'drills': [
                    {
                        'code': '12-1',
                        'name': 'Conducting a Primary Search Using the Standard Search Method',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '12-2',
                        'name': 'Conducting a Primary Search Using the Oriented Search Method',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '12-3',
                        'name': 'Performing a Secondary Search',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '12-4',
                        'name': 'Performing a One-Person Walking Assist',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '12-5',
                        'name': 'Performing a Two-Person Walking Assist',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '12-6',
                        'name': 'Performing a Two-Person Extremity Carry',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '12-7',
                        'name': 'Performing a Two-Person Seat Carry',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '12-8',
                        'name': 'Performing a Two-Person Chair Carry',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '12-9',
                        'name': 'Performing a Cradle-in-Arms Carry',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '12-10',
                        'name': 'Performing a Clothes Drag',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '12-11',
                        'name': 'Performing a Blanket Drag',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '12-12',
                        'name': 'Performing a Standing Drag',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '12-13',
                        'name': 'Performing a Webbing Sling Drag',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '12-14',
                        'name': 'Performing a Fire Fighter Drag',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '12-15',
                        'name': 'Performing a One-Person Emergency Drag from a Vehicle',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '12-16',
                        'name': 'Rescuing a Conscious Victim from a Window',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '12-17',
                        'name': 'Rescuing an Unconscious Victim from a Window',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '12-18',
                        'name': 'Rescuing an Unconscious Child or Small Adult from a Window',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '12-19',
                        'name': 'Rescuing a Large Adult from a Window',
                        'level': 'Fire Fighter I'
                    }
                ]
            },
            {
                'chapter': 18,
                'label': 'Firefighter Survival',
                'group': 'interior',
                'skillKey': 'ch18Survival',
                'exam': 9,
                'drills': [
                    {
                        'code': '18-1',
                        'name': 'Initiating a Mayday Call for Emergency Assistance',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '18-2',
                        'name': 'Performing Self-Rescue Using a Hose Line',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '18-3',
                        'name': 'Locating a Door or Window for Emergency Exit',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '18-4',
                        'name': 'Backhanded Swim Technique to Escape Through a Wall',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '18-5',
                        'name': 'Forward Swim Technique to Escape Through a Wall',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '18-6',
                        'name': 'Escaping from an Entanglement',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '18-7',
                        'name': 'Rescuing a Downed Fire Fighter Using SCBA Straps as a Rescue Harness',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '18-8',
                        'name': 'Rescuing a Downed Fire Fighter Using a Drag Rescue Device',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '18-9',
                        'name': 'Rescuing a Downed Fire Fighter as a Two-Person Team',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '18-10',
                        'name': 'Supplying Air to a Downed Fire Fighter Using the Low-Pressure Hose',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '18-11',
                        'name': 'Supplying Air to a Downed Fire Fighter Using the High-Pressure Hose',
                        'level': 'Fire Fighter I'
                    }
                ]
            },
            {
                'chapter': 8,
                'label': 'FF Tools & Equipment',
                'group': 'interior',
                'skillKey': 'ch8Tools',
                'exam': 10,
                'drills': [
                    {
                        'code': '8-1',
                        'name': 'Cleaning and Inspecting Hand Tools',
                        'level': 'Fire Fighter I'
                    }
                ]
            },
            {
                'chapter': 10,
                'label': 'Forcible Entry',
                'group': 'interior',
                'skillKey': 'ch10ForcibleEntry',
                'exam': 10,
                'drills': [
                    {
                        'code': '10-1',
                        'name': 'Forcing Entry into an Inward-Opening Door',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '10-2',
                        'name': 'Forcing Entry into an Outward-Opening Door',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '10-3',
                        'name': 'Opening an Overhead Garage Door',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '10-4',
                        'name': 'Opening an Overhead Garage Door Using the Hinge Method',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '10-5',
                        'name': 'Forcing Entry Through a Wooden Double-Hung Window',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '10-6',
                        'name': 'Forcing Entry Through a Casement Window',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '10-7',
                        'name': 'Forcing Entry Through a Projected Window',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '10-10',
                        'name': 'Forcing Entry by Unscrewing the Lock',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '10-11',
                        'name': 'Breaching a Wall Frame',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '10-12',
                        'name': 'Breaching a Masonry Wall',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '10-13',
                        'name': 'Breaching a Metal Wall',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '10-14',
                        'name': 'Breaching a Floor',
                        'level': 'Fire Fighter I'
                    }
                ]
            },
            {
                'chapter': 19,
                'label': 'Salvage & Overhaul',
                'group': 'interior',
                'skillKey': 'ch19Salvage',
                'exam': 11,
                'drills': [
                    {
                        'code': '19-1',
                        'name': 'Illuminating an Emergency Scene',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '19-2',
                        'name': 'Using Sprinkler Wedges',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '19-3',
                        'name': 'Using a Sprinkler Stop',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '19-4',
                        'name': 'Closing and Reopening a Main OS&Y Valve',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '19-5',
                        'name': 'Closing and Reopening a Main Post Indicator Valve',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '19-6',
                        'name': 'Constructing a Water Chute',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '19-7',
                        'name': 'Constructing a Water Catch-All',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '19-8',
                        'name': 'Performing a Salvage Cover Fold for One-Fire Fighter Deployment',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '19-9',
                        'name': 'Performing a Salvage Cover Fold for Two-Fire Fighter Deployment',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '19-10',
                        'name': 'Folding and Rolling a Salvage Cover',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '19-11',
                        'name': 'Performing a One-Person Salvage Cover Roll',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '19-12',
                        'name': 'One-Fire Fighter Salvage Cover Shoulder Toss',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '19-13',
                        'name': 'Two-Fire Fighter Salvage Cover Balloon Toss',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '19-14',
                        'name': 'Using a Multi-gas Metre',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '19-15',
                        'name': 'Pulling a Ceiling Using a Pike Pole',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '19-16',
                        'name': 'Opening an Interior Wall',
                        'level': 'Fire Fighter I'
                    }
                ]
            },
            {
                'chapter': 28,
                'label': 'Fire Origin & Cause',
                'group': 'interior',
                'skillKey': 'ch28Origin',
                'exam': 11,
                'drills': [],
                'theoryOnly': true
            },
            {
                'chapter': 24,
                'label': 'Vehicle Rescue & Extrication',
                'group': 'interior',
                'skillKey': 'ch24Vehicle',
                'exam': 12,
                'drills': [
                    {
                        'code': '24-1',
                        'name': 'Disable the Electrical System of an Electric Drive Vehicle',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '24-2',
                        'name': 'Performing a Scene Size-Up at a Motor Vehicle Accident',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '24-3',
                        'name': 'Mitigating the Hazards at a Motor Vehicle Accident',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '24-4',
                        'name': 'Stabilizing a Vehicle Following a Motor Vehicle Accident',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '24-5',
                        'name': 'Breaking Tempered Glass',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '24-6',
                        'name': 'Gaining Access to a Vehicle Following a Motor Vehicle Accident',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '24-7',
                        'name': 'Forcing a Vehicle Door',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '24-8',
                        'name': 'Gaining Access and Providing Medical Care to a Victim in a Vehicle',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '24-9',
                        'name': 'Performing a Dash Roll',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '24-10',
                        'name': 'Performing a Dash Lift',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '24-11',
                        'name': 'Removing the Roof of a Vehicle',
                        'level': 'Fire Fighter II'
                    }
                ]
            },
            {
                'chapter': 25,
                'label': 'Assisting Special Rescue',
                'group': 'interior',
                'skillKey': 'ch25SpecialRescue',
                'exam': 12,
                'drills': [
                    {
                        'code': '25-1',
                        'name': 'Establishing a Barrier',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '25-2',
                        'name': 'Identifying and Retrieving Rescue Tools',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '25-3',
                        'name': 'Conducting a Weekly/Monthly Generator Test',
                        'level': 'Fire Fighter II'
                    }
                ]
            },
            {
                'chapter': 23,
                'label': 'Advanced Fire Suppression (Live Fire)',
                'group': 'interior',
                'skillKey': 'ch23AdvLiveFire',
                'exam': 13,
                'drills': [
                    {
                        'code': '23-1',
                        'name': 'Coordinating an Interior Attack',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '23-2',
                        'name': 'Suppressing a Flammable Gas Cylinder Fire',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '23-3',
                        'name': 'Operating an In-Line Foam Eductor',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '23-4',
                        'name': 'Performing the Rain-Down Method of Applying Foam',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '23-5',
                        'name': 'Performing the Roll-In Method of Applying Foam',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '23-6',
                        'name': 'Performing the Bounce-Off Method of Applying Foam',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '23-7',
                        'name': 'Performing an Annual Service Test on a Fire Hose',
                        'level': 'Fire Fighter II'
                    }
                ]
            }
        ],
        'exams': [
            {
                'exam': 9,
                'label': 'Written Exam 9',
                'chapters': [
                    12,
                    18
                ]
            },
            {
                'exam': 10,
                'label': 'Written Exam 10',
                'chapters': [
                    8,
                    10
                ]
            },
            {
                'exam': 11,
                'label': 'Written Exam 11',
                'chapters': [
                    19,
                    28
                ]
            },
            {
                'exam': 12,
                'label': 'Written Exam 12',
                'chapters': [
                    24,
                    25
                ]
            },
            {
                'exam': 13,
                'label': 'Written Exam 13',
                'chapters': [
                    23
                ]
            }
        ]
    },
    'fullService': {
        'key': 'fullService',
        'label': 'Full Service Operations',
        'order': 3,
        'chapters': [
            {
                'chapter': 27,
                'label': 'Fire & Life Safety',
                'group': 'fullService',
                'skillKey': 'ch27LifeSafety',
                'exam': 14,
                'drills': [
                    {
                        'code': '27-1',
                        'name': 'Teaching Stop, Drop, and Roll',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '27-2',
                        'name': 'Teaching E.D.I.T.H.',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '27-3',
                        'name': 'Installing and Maintaining Smoke Alarms',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '27-4',
                        'name': 'Conducting a Fire Station Tour',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '27-5',
                        'name': 'Conducting a Fire Safety Survey',
                        'level': 'Fire Fighter II'
                    },
                    {
                        'code': '27-6',
                        'name': 'Conducting a Preincident Survey',
                        'level': 'Fire Fighter II'
                    }
                ]
            },
            {
                'chapter': 7,
                'label': 'Portable Extinguishers',
                'group': 'fullService',
                'skillKey': 'ch7Extinguishers',
                'exam': 15,
                'drills': [
                    {
                        'code': '7-1',
                        'name': 'Transporting a Fire Extinguisher',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '7-2',
                        'name': 'Extinguishing a Class A Fire with a Stored-Pressure Water Extinguisher',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '7-3',
                        'name': 'Extinguishing a Class A Fire with a Multipurpose Dry-Chemical Extinguisher',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '7-4',
                        'name': 'Extinguishing a Class B Flammable Liquid Fire with a Dry-Chemical Extinguisher',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '7-5',
                        'name': 'Extinguishing a Class B Flammable Liquid Fire with a Stored-Pressure Foam Extinguisher',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '7-6',
                        'name': 'Operating a Carbon Dioxide Fire Extinguisher',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '7-7',
                        'name': 'Operating a Halogenated Stored-Pressure Fire Extinguisher',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '7-8',
                        'name': 'Operating a Dry-Powder Fire Extinguisher',
                        'level': 'Fire Fighter I'
                    },
                    {
                        'code': '7-9',
                        'name': 'Operating a Wet-Chemical Fire Extinguisher',
                        'level': 'Fire Fighter I'
                    }
                ]
            },
            {
                'chapter': 26,
                'label': 'Detection/Suppression Systems',
                'group': 'fullService',
                'skillKey': 'ch26Detection',
                'exam': 15,
                'drills': [],
                'theoryOnly': true
            }
        ],
        'exams': [
            {
                'exam': 14,
                'label': 'Written Exam 14',
                'chapters': [
                    27
                ]
            },
            {
                'exam': 15,
                'label': 'Written Exam 15',
                'chapters': [
                    7,
                    26
                ]
            }
        ]
    }
};

module.exports = SkillDrills;
